import { mapActions } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';

export default {
  mixins: [
    formMixin,
  ],
  validations: {
    fields: {
      currentPassword: validators.required,
      newPassword: validators.password,
      newPasswordConfirmation: validators.passwordConfirmation('newPassword'),
    },
  },
  data() {
    return {
      fields: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      },
    };
  },
  methods: {
    ...mapActions('notifications', ['setSuccessSideNotificationWithTimeoutCallback']),
    ...mapActions('user', ['changePassword']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          oldPassword: this.fields.currentPassword,
          newPassword: this.fields.newPassword,
          confirmPassword: this.fields.newPasswordConfirmation,
        };
        this.changePassword(payload)
          .then(this.formEnable)
          .then(() => {
            this.setSuccessSideNotificationWithTimeoutCallback({
              text: 'Password Updated.',
              callback: () => this.$router.go(-1),
            });
          })
          .catch(this.formHandleErrors);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-update-password/account-update-password.js